import { ReactElement, useEffect, useState } from 'react';
import { CreateAdminForm, CreateAdminFormData } from '../create-admin-form';
import { useOpenApi } from '../../../core/providers';
import { parseApiError } from '@techshift/react-core';
import { AppToaster } from '../../../core/util';
import { CreateAdminResponseData } from '@techshift/callie-private-api-typescript';
import { CreatedAdmin } from '../created-admin';

export type CreateAdminProps = {
	onSuccess?: () => void;
};
export function CreateAdmin(props: CreateAdminProps): ReactElement {
	const { onSuccess } = props;

	const { openApi } = useOpenApi();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const [createdAdmin, setCreatedAdmin] =
		useState<CreateAdminResponseData | null>(null);

	useEffect(() => {
		if (error) {
			AppToaster.show({ message: error, intent: 'danger' });
		}
	}, [error]);

	const onSubmit = ({ firstName, lastName, email }: CreateAdminFormData) => {
		setLoading(true);
		setError('');
		openApi.admins
			.createAdmin({ firstName, lastName, email })
			.then((response) => {
				AppToaster.show({ message: 'Admin created', intent: 'success' });
				setCreatedAdmin(response.data.data);
				onSuccess?.();
			})
			.catch((error) => {
				parseApiError({
					error,
					unknownError: () => {
						setError('Unknown error');
					},
					requestError: () => {
						setError('Unable to reach server');
					},
					responseError: ({ response }) => {
						if (response.data.message === 'ADMIN_ALREADY_EXISTS') {
							setError('Admin with this email already exists');
						} else {
							setError('Unknown error');
						}
					}
				});
			})
			.finally(() => setLoading(false));
	};
	return (
		<>
			{createdAdmin === null ? (
				<CreateAdminForm loading={loading} onSubmit={onSubmit} />
			) : (
				<CreatedAdmin
					admin={createdAdmin.admin}
					password={createdAdmin.password}
					onCreateAnother={() => {
						setCreatedAdmin(null);
					}}
				/>
			)}
		</>
	);
}
